/* eslint-disable no-param-reassign */

import productApi from '@/apis/product';
import { ASSETS_IMAGE_THUMBS_PATH } from '@/utils/constants';

const recommendationCategories = [
  {
    packCategoryCode: 'PC01',
    packCategoryName: '마이 원픽 팩',
    packMappingName: 'myone_pick',
  },
  {
    packCategoryCode: 'PC02',
    packCategoryName: 'ABC 팩',
    packMappingName: 'detox',
  },
  {
    packCategoryCode: 'PC03',
    packCategoryName: '키즈 하이 팩',
    packMappingName: 'kis_high',
  },
  {
    packCategoryCode: 'PC04',
    packCategoryName: '포커스 팩',
    packMappingName: 'focus',
  },
  {
    packCategoryCode: 'PC05',
    packCategoryName: 'W 4050 팩',
    packMappingName: 'female',
  },
  {
    packCategoryCode: 'PC06',
    packCategoryName: 'M 4050 팩',
    packMappingName: 'male',
  },
  {
    packCategoryCode: 'PC07',
    packCategoryName: '울트라55 팩',
    packMappingName: 'ultra',
  },
  {
    packCategoryCode: 'PC08',
    packCategoryName: '항산화 팩',
    packMappingName: 'beauty',
  },
  {
    packCategoryCode: 'PC09',
    packCategoryName: '아이 러브 팩',
    packMappingName: 'eye_love',
  },
  {
    packCategoryCode: 'PC10',
    packCategoryName: '행오버 팩',
    packMappingName: 'hangover',
  },
  {
    packCategoryCode: 'PC11',
    packCategoryName: '에브리데이 팩',
    packMappingName: 'everyday',
  },
];

export default {
  namespaced: true,
  state: () => ({
    recommendationsFetched: false,
    recommendations: [],
    recommendationCategories,
  }),
  mutations: {
    init(state, payload) {
      state.recommendations = payload;
      state.recommendationsFetched = true;
    },
  },
  actions: {
    async init({
      commit,
    }) {
      const r = await productApi.getAllRecommendationProducts();
      commit('init', r);
    },
  },
  getters: {
    recommendationCategories: (state) => state.recommendationCategories,
    recommendationsFetched: (state) => state.recommendationsFetched,
    recommendations: (state) => {
      const r = state.recommendations.map((n) => {
        const packAdditionals = n.pack_detail.reduce(
          (acc, n2) => {
            const {
              price,
              pv,
              bv,
            } = n2;
            let totalPrice = 0;
            let totalPv = 0;
            let totalBv = 0;
            const doseInfo = {
              s1: 0,
              s2: 0,
              s3: 0,
            };

            n2.dose_detail.forEach((x) => {
              totalPrice += price * x.dose_cnt * n.take_days;
              totalPv += pv * x.dose_cnt * n.take_days;
              totalBv += bv * x.dose_cnt * n.take_days;
              doseInfo[`s${x.dose_seq}`] = x.dose_cnt;
            });

            acc.packPrice += totalPrice;
            acc.packPv += totalPv;
            acc.packBv += totalBv;

            acc.pack_detail.push({
              ...n2,
              doseSeqs: `${doseInfo.s1},${doseInfo.s2},${doseInfo.s3}`,
              dosePerDay: n2.dose_detail.length,
            });

            return acc;
          }, {
            packPrice: 0,
            packPv: 0,
            packBv: 0,
            pack_detail: [],
          },
        );
        const recomendation = {
          ...n,
          ...packAdditionals,
        };
        const maxDoseCount = recomendation.pack_detail.reduce(
          (bigger, x) => Math.max(bigger, x.dosePerDay),
          0,
        );
        recomendation.maxDoseCount = maxDoseCount;

        // morph pack details into dose components
        const pockets = [
          {
            dose_seq: 1,
            items: [],
          },
          {
            dose_seq: 2,
            items: [],
          },
          {
            dose_seq: 3,
            items: [],
          },
        ];

        recomendation.pack_detail.forEach((n2) => {
          const doseSeqs = n2.doseSeqs.split(',');
          doseSeqs.forEach((d, idx) => {
            if (d > 0) {
              pockets[idx].items.push({
                item_sku: n2.item_sku,
                item_name: n2.item_name,
                hashes: n2.explain.split('#').filter((h) => h.length > 0),
                dose_cnt: d,
                img_url: `${ASSETS_IMAGE_THUMBS_PATH}/${n2.item_sku}.jpg`,
                outlink: `https://${process.env.SSO_HOST}/p/${n2.item_sku}/mpn`,
                display: n2.display,
              });
            }
          });
        });
        recomendation.components = pockets.filter((x) => x.items.length > 0);

        return recomendation;
      });
      return r;
    },
  },
};
